import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import * as cnst from '../ts/consts';
import ShopItemsRoot from './containers/shop-items-root';
const fileNameItems = `./assets/json/shops.json?${cnst.DATE_NOW}`;
const fileNameOrder = `./assets/json/shops-order.json?${cnst.DATE_NOW}`;
// 商品一覧と並び順データの取得
Promise.all([
    axios.get(fileNameItems),
    axios.get(fileNameOrder)
]).then((res) => {
    ReactDOM.render(React.createElement(ShopItemsRoot, { shopItems: res[0].data, shopItemsOrder: res[1].data }), document.getElementById('shops'));
});
